import React, {useState, useEffect} from 'react';
import Search from "../../components/Search";
import ProductFilter from "../../components/ProductFilter";
import Product from "../../components/Product";
import {addToCart, getProducts, addToWishlist, addFreeToCart} from "../../services/products";
import Pager from "../../components/Pager";
import {useFilter} from "./FilterContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import './Marketplace.scss';

const Marketplace = () => {
    const {filterCategoryId, setCartCount} = useFilter();
    const [productsArray, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isListView, setIsListView] = useState(false);
    const [isNotification, setIsNotification] = useState();
    const [isNotificationWarning, setIsNotificationWarning] = useState(false);
    const [filterParams, setFilterParams] = useState({
        sort: '',
        show: 25,
        types: [],
    });
    const [pagination, setPagination] = useState({
        total: '',
        current: '1'
    });

    const handleClick = (pageNumber) => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            current: pageNumber,
        }));
        fetchFilteredProducts({...filterParams, filterCategoryId: filterCategoryId, page: Number(pageNumber)});
    };

    const toggleViewMode = () => {
        setIsListView((prevIsListView) => !prevIsListView);
    };

    const fetchFilteredProducts = async (filterParams) => {
        try {
            const products = await getProducts(filterParams);
            setProducts(products.data);
            setPagination((prevPagination) => ({
                ...prevPagination,
                total: products.total,
            }));
            setLoading(false);
        } catch (error) {
            setError(error);
            setLoading(false);
        }
    };

    const addToCardHandler = async (productId) => {
        let result = await addToCart(productId);

        if (result.success) {
            setIsNotification(result.success);
            const totalValue = result.total;
            const itemCount = totalValue.split(' ')[0];
            setCartCount(itemCount);
        } else {
            setIsNotificationWarning(true);
            setIsNotification(result.error.warning);
        }

        setTimeout(() => {
            setIsNotification('');
            setIsNotificationWarning(false);
        }, 5000);
    };

    const addToWishlistHandler = async (productId) => {
        const result = await addToWishlist(productId);
        setIsNotification(result.success);
        setTimeout(() => {
            setIsNotification('');
        }, 5000);
    }

    useEffect(() => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            current: '1',
        }));
        fetchFilteredProducts({...filterParams, filterCategoryId: filterCategoryId, page: '1'});

    }, [filterParams, filterCategoryId]);

    if (loading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error loading data: {error.message}</div>;
    }

    const addFreeToCardHandler = async (productId) => {
        const result = await addFreeToCart(productId);
        if (result.error) {
            setIsNotificationWarning(true);
            setIsNotification(result.error.warning);
        } else {
            setIsNotification(result.success);
        }
        setTimeout(() => {
            setIsNotification('');
            setIsNotificationWarning(false)
        }, 5000);
    }

    return (
        <div>
            <SubHeader filterParams={filterParams} fetchFilteredProducts={fetchFilteredProducts}/>
            <div className="section-content">
                <Search/>
                <div className="content">
                    <ProductFilter onToggleViewMode={toggleViewMode} filters={filterParams}
                                   setFilters={setFilterParams}/>
                    <div className={isListView ? 'product-list' : 'product-grid'}>
                        {productsArray.map((product) => (
                            <Product key={product.name} product={product} addToCardHandler={addToCardHandler}
                                     addToWishlistHandler={addToWishlistHandler} addFreeToCardHandler={addFreeToCardHandler}/>
                        ))}
                    </div>
                    <Pager total={Number(pagination.total)} itemsPerPage={Number(filterParams.show)}
                           currentPage={Number(pagination.current)} handleClick={handleClick}/>
                </div>
            </div>
            <div className={`notification ${isNotification ? 'notification-active' : '_notification-active'} ${isNotificationWarning ? 'notification--red' : ''}`}>
                {isNotification && (
                    <div dangerouslySetInnerHTML={{__html: isNotification}}/>
                )}
                <button className="btn-close" onClick={() => { setIsNotification(''); setIsNotificationWarning(''); }}>
            <span>
                <i className="times-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
                    </svg>
                </i>
            </span>
                </button>
            </div>
        </div>
    );
};

export default Marketplace;